import * as Yup from "yup";
import {
  FIELD_REQUIRED,
} from "../../../common/constants/validationErrors";

export const LoginValidationSchema = Yup.object().shape({
  username: Yup.string().required(FIELD_REQUIRED),
  password: Yup.string().required(FIELD_REQUIRED)
});
